import {
  ExtractFnReturnType,
  InfiniteQueryConfigType,
  useInfiniteQuery,
  UseInfiniteQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import {
  ApiManagersBelongingEmployeesKpiTermsIndexRequestType,
  ApiManagersBelongingEmployeesKpiTermsIndexResponseType,
} from "~/domains";

type RequestDataType = {
  params?: ApiManagersBelongingEmployeesKpiTermsIndexRequestType;
  page?: number;
};

const request = async ({
  params,
  page = 1,
}: RequestDataType): Promise<ApiManagersBelongingEmployeesKpiTermsIndexResponseType> => {
  const response =
    await new ApiClient().get<ApiManagersBelongingEmployeesKpiTermsIndexResponseType>(
      "/api/managers/belonging_employees/kpi_terms",
      { page, ...params },
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  params?: ApiManagersBelongingEmployeesKpiTermsIndexRequestType;
  config?: InfiniteQueryConfigType<QueryFnType>;
};

export const useApisManagersBelongingEmployeesKpiTermsIndex = ({
  params,
  config = {},
}: PropsType = {}): UseInfiniteQueryResult<ApiManagersBelongingEmployeesKpiTermsIndexResponseType> => {
  return useInfiniteQuery<ExtractFnReturnType<QueryFnType>>(
    ["ApisManagersBelongingEmployeesKpiTermsIndex", params],
    ({ pageParam }) => {
      return request({ params, page: pageParam as number | undefined });
    },
    {
      ...config,
      getNextPageParam: (data) => {
        return data.pagy.hasMore ? data.pagy.currentPage + 1 : false;
      },
    },
  );
};
